/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_api as api,
  rec_dC as dC,
  rec_es as es,
  rec_kr as kr,
  rec_sS as sS,
  rec_st as st,
  rec_uS as uS,
  rec_vC as vC,
  rec_xr as xr,
} from "../../runtime/index.jsx";
export function PanelNotificaciones() {
  let e = st(),
    t = Go(),
    [n, r] = (0, React.useState)(!1),
    [i, a] = (0, React.useState)(0),
    [o, s] = (0, React.useState)([]),
    // Versión nueva del planner: en escritorio se avisa acá y no con un cartel abajo (2026-10-08).
    [versionNueva, setVersionNueva] = (0, React.useState)(() => !!window.__versionNueva),
    c = (0, React.useRef)(null),
    l = (0, React.useCallback)(() => {
      api(`/notificaciones/conteo`, {
        redirigirEn401: !1,
      })
        .then((e) => a(e?.noLeidas ?? 0))
        .catch(() => {});
    }, []);
  ((0, React.useEffect)(() => {
    let v = () => setVersionNueva(!0);
    return (window.addEventListener(`version-nueva`, v), () => window.removeEventListener(`version-nueva`, v));
  }, []),
  (0, React.useEffect)(() => {
    l();
    let e = setInterval(l, 12e4);
    return (
      window.addEventListener(`focus`, l),
      window.addEventListener(`sesion-actualizada`, l),
      () => {
        (clearInterval(e),
          window.removeEventListener(`focus`, l),
          window.removeEventListener(`sesion-actualizada`, l));
      }
    );
  }, [l]),
    (0, React.useEffect)(
      () =>
        dC((e) => {
          if (e.notificacion != null) {
            (a(e.noLeidas),
              s((t) =>
                [
                  e.notificacion,
                  ...t.filter((t) => t.id !== e.notificacion.id),
                ].slice(0, 12),
              ),
              es(`aviso`));
            try {
              navigator.vibrate?.(180);
            } catch {}
            document.hidden
              ? vC(e.notificacion)
              : t.info(e.notificacion.titulo);
          }
        }),
      [t],
    ),
    (0, React.useEffect)(() => {
      if (!n) return;
      api(`/notificaciones?limite=12`)
        .then(s)
        .catch(() => {});
      let e = (e) => {
          c.current && !c.current.contains(e.target) && r(!1);
        },
        t = (e) => e.key === `Escape` && r(!1);
      return (
        document.addEventListener(`mousedown`, e),
        document.addEventListener(`keydown`, t),
        () => {
          (document.removeEventListener(`mousedown`, e),
            document.removeEventListener(`keydown`, t));
        }
      );
    }, [n]));
  async function u(t) {
    (t.leida ||
      (await api(`/notificaciones/${t.id}/leida`, {
        method: `POST`,
      }).catch(() => {}),
      a((e) => Math.max(0, e - 1))),
      r(!1),
      t.enlace && e(t.enlace));
  }
  async function f() {
    (await api(`/notificaciones/leidas`, {
      method: `POST`,
    }).catch(() => {}),
      a(0),
      s((e) =>
        e.map((e) => ({
          ...e,
          leida: !0,
        })),
      ));
  }
  return (
    <div
      className={`relative`}
      ref={c}
      children={[
        <button
          type={`button`}
          onClick={() => r((e) => !e)}
          aria-label={`Notificaciones`}
          className={`relative rounded-lg p-1.5 text-(--text) transition hover:bg-(--accent-bg) hover:text-(--text-h)`}
          children={[
            (0, JSXRuntime.jsx)(xr, {
              className: `h-5 w-5`,
            }),
            i > 0 && (
              <span
                className={`absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-(--error) px-1 text-[10px] font-semibold text-white`}
                children={i > 9 ? `9+` : i}
              />
            ),
            i === 0 && versionNueva && (
              <span
                aria-label={`Hay una versión nueva`}
                className={`absolute right-0.5 top-0.5 h-2.5 w-2.5 rounded-full border-2 border-(--bg) bg-(--accent)`}
              />
            ),
          ]}
        />,
        n && (
          <div
            className={`animar-entrada absolute right-0 z-40 mt-2 w-80 overflow-hidden rounded-2xl border border-(--border) bg-(--bg) shadow-2xl`}
            children={[
              <div
                className={`flex items-center justify-between border-b border-(--border) px-3 py-2`}
                children={[
                  <span
                    className={`text-sm font-medium text-(--text-h)`}
                    children={`Notificaciones`}
                  />,
                  i > 0 && (
                    <button
                      type={`button`}
                      onClick={f}
                      className={`flex items-center gap-1 text-xs text-(--accent) hover:underline`}
                      children={[
                        (0, JSXRuntime.jsx)(kr, {
                          className: `h-3 w-3`,
                        }),
                        ` Marcar todo`,
                      ]}
                    />
                  ),
                ]}
              />,
              <ul
                className={`max-h-96 overflow-y-auto`}
                children={[
                  versionNueva && (
                    <li
                      key={`version-nueva`}
                      className={`flex items-center gap-3 border-b border-(--border) bg-(--accent-bg) px-3 py-2.5`}
                      children={[
                        <span
                          className={`flex min-w-0 flex-1 flex-col`}
                          children={[
                            <span className={`text-sm font-medium text-(--text-h)`} children={`Hay una versión nueva del planner`} />,
                            <span className={`text-xs text-(--text)`} children={`Actualiza para tener los últimos cambios.`} />,
                          ]}
                        />,
                        <button
                          type={`button`}
                          onClick={() => window.dispatchEvent(new CustomEvent(`actualizar-app`))}
                          className={`shrink-0 rounded-full bg-(--accent) px-3 py-1.5 text-xs font-medium text-(--accent-fg) transition hover:opacity-90`}
                          children={`Actualizar`}
                        />,
                      ]}
                    />
                  ),
                  o.length === 0 && !versionNueva && (
                    <li
                      className={`px-3 py-6 text-center text-sm text-(--text)`}
                      children={`Sin notificaciones.`}
                    />
                  ),
                  o.map((e) => (
                    <li
                      key={e.id}
                      children={
                        <button
                          type={`button`}
                          onClick={() => u(e)}
                          className={`flex w-full flex-col items-start gap-0.5 border-b border-(--border) px-3 py-2.5 text-left transition hover:bg-(--accent-bg) ${e.leida ? `` : `bg-(--accent-bg)/40`}`}
                          children={[
                            <span
                              className={`flex w-full items-center gap-2`}
                              children={[
                                !e.leida && (
                                  <span
                                    className={`h-1.5 w-1.5 shrink-0 rounded-full bg-(--accent)`}
                                  />
                                ),
                                <span
                                  className={`min-w-0 flex-1 truncate text-sm font-medium text-(--text-h)`}
                                  children={e.titulo}
                                />,
                                <span
                                  className={`shrink-0 text-[11px] text-(--text)`}
                                  children={uS(e.creadoEn)}
                                />,
                              ]}
                            />,
                            e.cuerpo && (
                              <span
                                className={`line-clamp-2 text-xs text-(--text)`}
                                children={e.cuerpo}
                              />
                            ),
                            <span
                              className={`text-[10px] uppercase tracking-wide text-(--text)/70`}
                              children={sS(e.tipo)}
                            />,
                          ]}
                        />
                      }
                    />
                  )),
                ]}
              />,
              <button
                type={`button`}
                onClick={() => {
                  (r(!1), e(`/notificaciones`));
                }}
                className={`w-full py-2 text-center text-xs font-medium text-(--accent) hover:bg-(--accent-bg)`}
                children={`Ver todas`}
              />,
            ]}
          />
        ),
      ]}
    />
  );
}
